
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M16.76 6.094c.57-.292 1.24.133 1.24.787l-.01.39c-.012.304-.04.695-.09 1.152a16.593 16.593 0 01-.705 3.36C16.14 14.988 14.156 17 11.065 17a5.357 5.357 0 01-2.97-.883 6.344 6.344 0 00-.546 1.308.789.789 0 01-.981.542.801.801 0 01-.536-.993 8.054 8.054 0 01.875-1.968A4.38 4.38 0 016 12.34c0-2.601 2.291-4.659 5.065-4.659l.467-.017.493-.048c.892-.115 1.86-.37 2.848-.726.503-.18.945-.36 1.3-.518l.587-.278zm-.564 2.132l-.006.038-.751.287c-1.094.394-2.175.68-3.201.81a9.23 9.23 0 01-1.173.08l-.425.023c-1.668.182-2.926 1.424-2.926 2.876 0 .432.111.845.312 1.218 1.036-1.091 2.376-1.96 3.92-2.512a.788.788 0 011.009.488.803.803 0 01-.482 1.02c-1.333.477-2.476 1.224-3.345 2.15.543.337 1.21.536 1.937.536 2.227 0 3.662-1.454 4.506-4.02.31-.946.513-1.969.625-2.994z"}})])
          )
        }
      }
    